<template>
  <div v-if="$store.state.showLoading" class="loaderOn">
    <div style="position:fixed;background-color:#000000;opacity:0.7;z-index:20000;width:100vw;height:100vh;">
      </div>
      <div :style="{backgroundColor: getCssColor('secondary_bt')}" style="border-radius:4px;color:#ffffff;position:fixed;z-index:20001;top:calc(50vh - 80px);left:calc(50vw - 100px);width:200px;height:100px;text-align:center;">
        <div style="margin:auto;margin-top:20px;">
        <font-awesome-icon class="loadingIcon" :icon="['fal', 'spinner']"/><br/>
        Aguarde
        </div>
      </div>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
export default {
  data () {
    return {
    }
  },
  name: 'Loading',
  mixins: [colors]
}
</script>

<style lang="scss" scoped>
.loadingIcon {
  color:#ffffff;
  font-size: 36px;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
@-moz-keyframes spin {
  from { -moz-transform: rotate(0deg); }
  to { -moz-transform: rotate(360deg); }
}
@-webkit-keyframes spin {
  from { -webkit-transform: rotate(0deg); }
  to { -webkit-transform: rotate(360deg); }
}
@keyframes spin {
  from {transform:rotate(0deg);}
  to {transform:rotate(360deg);}
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1,1);
  }
  50% {
    transform: scale(1.2,1.2);
  }
  100% {
    transform: scale(1,1);
  }
}

.zoom {
  animation: zoominoutsinglefeatured 0.2s infinite ;
}

</style>
